import { ApolloProvider as ApolloProviderV1 } from "react-apollo";
import { ApolloProvider as ApolloProviderV2 } from "@apollo/client";
import React from "react";
import { ApolloClient as ApolloClientV1 } from "apollo-client";
import { ApolloClient as ApolloClientV2 } from "@apollo/client";

type TCacheV1 = ApolloClientV1<unknown>["cache"];
type TCacheV2 = ApolloClientV2<unknown>["cache"];

type ApolloProviderProps = {
  children: React.ReactNode;
  clientV1: ApolloClientV1<TCacheV1>;
  clientV2: ApolloClientV2<TCacheV2>;
};

const ApolloProvider: React.FC<ApolloProviderProps> = ({ children, clientV1, clientV2 }) => {
  return (
    <ApolloProviderV1 client={clientV1}>
      <ApolloProviderV2 client={clientV2}>{children}</ApolloProviderV2>
    </ApolloProviderV1>
  );
};

export default ApolloProvider;
